$(function (){
    /* set height of sidebar */
    $(window).on('resize', function() {
        var getHeightScreen = $(window).innerHeight();
        $('.content-topic5-sidebar-pantau-pelaksanaan').css("height", getHeightScreen);
    });
    var getHeightScreen = $(window).innerHeight();
    $('.content-topic5-sidebar-pantau-pelaksanaan').css("height", getHeightScreen);

    /* sidebar */
    $(".btn-close, .outside-kabar-terkirini-sidebar").click(function() {
        $('body').removeClass('is-locked');
        $('.content-topic5-sidebar-pantau-pelaksanaan').removeClass('show-sidebar');
        $('.content-topic5-sidebar-pantau-pelaksanaan').css("right", "-640px");
    });
    $(".latest-news-link").click(function(e) {
        if($(window).width() > 1024) {
            e.preventDefault();
            $('body').addClass('is-locked');
            $('.content-topic5-sidebar-pantau-pelaksanaan').addClass('show-sidebar');
            $('.content-topic5-sidebar-pantau-pelaksanaan').css("right", "0");
        } else {

        }
    });
});